import Introduction from "../../componets/Introduction";

export default function Section2() {
  return (
    <div className="Section2">
      <Introduction
        title="Introduction"
        text="Our surveillance model is designed to proactively determine crime and secure business at a fraction of the cost of guards and on-site surveillance. Our CCTV monitoring services have helped hundreds of Homeowners & Companies, Restaurants, Grocery Stores, Gas stations, Storage facilities across various sectors stay safe and secure."
        divider={true}
      />
    </div>
  );
}
